class AnaLuzTheme {
  constructor() {
    this.drawer = document.querySelector('[data-cart-drawer]');
    this.bindEvents();
  }
  bindEvents() {
    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-cart-open]')) this.openCart();
      if (event.target.closest('[data-cart-close]')) this.closeCart();
      const menu = event.target.closest('[data-menu-toggle]');
      if (menu) document.querySelector('[data-mobile-nav]')?.classList.toggle('is-open');
      const adjust = event.target.closest('[data-quantity-adjust]');
      if (adjust) {
        const input = adjust.parentElement.querySelector('input');
        input.value = Math.max(1, Number(input.value) + Number(adjust.dataset.quantityAdjust));
      }
    });
    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-product-form]');
      if (!form) return;
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      button.disabled = true;
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error('No se pudo añadir el producto.');
        await this.openCart();
      } catch (error) { alert(error.message); }
      finally { button.disabled = false; }
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') this.closeCart(); });
  }
  async openCart() {
    if (!this.drawer) return;
    const response = await fetch(window.Shopify.routes.root + 'cart.js');
    const cart = await response.json();
    this.renderCart(cart);
    this.drawer.classList.add('is-open');
    this.drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
  }
  closeCart() {
    this.drawer?.classList.remove('is-open');
    this.drawer?.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  }
  money(cents) { return new Intl.NumberFormat(document.documentElement.lang || 'es-ES', { style:'currency', currency: window.Shopify.currency.active }).format(cents / 100); }
  renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    const target = this.drawer.querySelector('[data-cart-content]');
    if (!cart.items.length) { target.innerHTML = '<div class="empty-state"><p>Tu carrito está vacío.</p><button class="button button--outline" data-cart-close>Seguir explorando</button></div>'; return; }
    target.innerHTML = cart.items.map(item => `<div class="cart-line">${item.image ? `<img src="${item.image}" alt="">` : ''}<div><strong>${item.product_title}</strong><p>${item.quantity} × ${this.money(item.final_price)}</p><a class="text-link" href="${window.Shopify.routes.root}cart/change?id=${encodeURIComponent(item.key)}&quantity=0">Eliminar</a></div></div>`).join('') + `<div class="cart-footer"><p class="cart-total"><span>Total</span><span>${this.money(cart.total_price)}</span></p><form action="${window.Shopify.routes.root}cart" method="post"><button class="button button--full" type="submit" name="checkout">Finalizar compra</button></form><p class="microcopy">Impuestos incluidos. Envío calculado en el pago.</p></div>`;
  }
}
document.addEventListener('DOMContentLoaded', () => new AnaLuzTheme());
